import { apiCall } from "../../../../_utils";
import { apiUrls } from "../../../../_constants";

export const adminMealPlanServices={
    getAllPendingFoodItems,
    getDailyMealRoaster,
    declinedMealPlan
}



function getAllPendingFoodItems(params){

 return apiCall("GET",apiUrls.food.mealPlan,null,params);
}

function getDailyMealRoaster(id){

    return apiCall("GET",`${apiUrls.food.mealPlan}/${id}/roster`);
   }


   function declinedMealPlan(request,id){
    return apiCall("POST",`${apiUrls.food.mealPlan}/${id}/review`,request);
}

